import {dashboardColumns} from "./dashboardTableConfig.ts";

export const TableSkeletonRow: React.FC = () => {
    // Renders the appropriate skeleton cell based on column type
    const renderSkeletonCell = (column: typeof dashboardColumns[0], index: number) => {
        const baseClasses = `px-1 py-1.5 ${column.align === "center" ? "text-center" : "text-left"} ${
            column.showOn ? `hidden ${column.showOn}:table-cell` : ""
        }`;

        switch(column.field) {
            case "usaFileNumber": // File #
                return (
                    <td key={index} className={baseClasses}>
                        <div className="flex flex-col items-center">
                            <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
                            <div className="h-3 w-6 mt-0.5 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </td>
                );
            case "orderStatus": // Status
                return (
                    <td key={index} className={baseClasses}>
                        <div className="h-5 w-16 bg-gray-200 rounded-full mx-auto animate-pulse" />
                    </td>
                );
            case "assignmentActualDate": // Assigned
            case "inspectionActualDate": // Inspected
                return (
                    <td key={index} className={baseClasses}>
                        <div className="h-4 w-14 bg-gray-200 rounded mx-auto animate-pulse" />
                    </td>
                );
            case "appraiserDueDate": // Due Date
                return (
                    <td key={index} className={baseClasses}>
                        <div className="h-5 w-14 bg-gray-200 rounded-full mx-auto animate-pulse" />
                    </td>
                );
            case "propertyAddressLine1": // Property
                return (
                    <td key={index} className={baseClasses}>
                        <div className="space-y-1">
                            <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                            <div className="h-3 w-16 bg-gray-100 rounded animate-pulse" />
                        </div>
                    </td>
                );
            case "borrowerName": // Borrower
                return (
                    <td key={index} className={baseClasses}>
                        <div className="h-4 w-12 bg-gray-200 rounded animate-pulse" />
                    </td>
                );
            case "appraiserName": // Appraiser
                return (
                    <td key={index} className={baseClasses}>
                        <div className="h-4 w-12 bg-gray-200 rounded animate-pulse" />
                    </td>
                );
            default:
                return (
                    <td key={index} className={baseClasses}>
                        <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
                    </td>
                );
        }
    };

    return (
        <tr className="hover:bg-gray-50/50">
            {dashboardColumns.map((column, index) => renderSkeletonCell(column, index))}
        </tr>
    );
};